import { CONTACTS } from '_constants';

export const contacts = (state = {}, action) => {
  let newState = { ...state };
  switch (action.type) {
    case CONTACTS.UPDATING_CONTACTS:
      newState = action.payload;
      break;
    default:
      break;
  }
  return newState;
};
